module.exports = __webpack_public_path__ + "static/media/logo-ltrent-full-test.f4fa0ac5.png";